/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-08-23 14:39:05
 */
import request from '@api/request.js'

// 企业申请状态
export const entCouponStatus = params =>
  request.get('/entCoupon/entCouponStatus', { params })

// 服务券列表
export const listCoupon = params =>
  request.get('/entCoupon/listCoupon', { params })

// 我的服务券列表
export const listEntCoupon = params =>
  request.get('/entCoupon/listEntCoupon', { params })

// 查询该企业最新领取的服务劵
export const entLatestCoupon = params =>
  request.get('/entCoupon/entLatestCoupon', { params })
// // 服务类型列表
// export const couponTypeList = params => request.get('/entCoupon/couponTypeList', { params })

// 服务券列表-详情
export const entCouponDetail = params =>
  request.get('/entCoupon/entCouponDetail', { params })

// 码上用券-企业申领详情
export const entWhiteDetail = params =>
  request.get('/entWhite/entWhiteDetail', { params })

// 文件上传
export const uploadFile = params =>
  request.upload(
    process.env.VUE_APP_BASE_API +
      process.env.VUE_APP_REQUEST_PREFIX3 +
      '/api/file/upload',
    params
  )

// 企业用券-企业申请白名单
export const insertOrUpdate = params =>
  request.post('/entWhite/insertOrUpdate', params)

// 企业领券券
export const insertOrCoupon = params =>
  request.post('/entCoupon/insertOrUpdate', params)

// 模板下载
export const downEntWhiteModel = params =>
  request.get('/entWhite/downEntWhiteModel', { params })

// 抢券列表
export const couponTypeList = params =>
  request.get('/entCoupon/couponTypeList', { params })

// 查询上架的服务券批次
export const findCouponInfo = params =>
  request.get('/entCoupon/findCouponInfo', { params })

// 商品列表
export const couponGoodsPage = params =>
  request.get('/entCoupon/couponGoodsPage', { params })

// 我的服务券时间设置
export const getEntWhiteSettingByType = params =>
  request.get('/entCoupon/getEntWhiteSettingByType', { params })

// 企业类型
export const getEntType = params =>
  request.get('/entWhite/getEntType', { params })
// 获取时间
export const findCurrentTime = params =>
  request.get('/entCoupon/findCurrentTime', { params })
